import React, { useState } from "react";
import ToastPopup from "./ToastPopup";
import { EditUserPopupProps, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import "../css/others/Popup.css";
import { validateField, nameValidationRules, emailValidationRules } from "../Reusablecomponents/Validation";
const EditUserPopup: React.FC<EditUserPopupProps> = ({ roles, editUserData, handleEditInputChange, handleSaveEditedUser, setIsEditUserPopupVisible, auditorSkills }) => {
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [fieldErrors, setFieldErrors] = useState<{ firstName?: string; lastName?: string; email?: string }>({});
  const [selectedSkills, setSelectedSkills] = useState<string[]>(editUserData?.skills || []);
  if (!editUserData) return null;
  const isAuditorRole = roles.find(role => role.id === editUserData.roleId)?.name.toLowerCase() === 'auditor';
  const allSkillValues = auditorSkills.map(s => s.value);
  const isAllSelected = allSkillValues.length > 0 && allSkillValues.every(v => selectedSkills.includes(v));
  const handleSkillChange = (skillValue: string) => {
    setSelectedSkills(prev => {
      const newSkills = prev.includes(skillValue) ? prev.filter(s => s !== skillValue) : [...prev, skillValue];
      handleEditInputChange({ target: { name: 'skills', value: newSkills } } as unknown as React.ChangeEvent<HTMLInputElement>);
      return newSkills;
    });
  };
  const handleInputChangeWithValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    handleEditInputChange(e);
    let error: string | null = null;
    if (name === 'firstName') {
      error = validateField(value, nameValidationRules, "First name");
    } else if (name === 'lastName') {
      error = validateField(value, nameValidationRules, "Last name");
    } else if (name === 'email') {
      error = validateField(value, emailValidationRules, "Email");
    }
    setFieldErrors(prev => ({ ...prev, [name]: error || undefined }));
  };
  const handleValidationAndSave = () => {
    const { firstName, lastName } = editUserData;
    const { firstName: firstNameError, lastName: lastNameError, email: emailError } = fieldErrors;
    if (firstNameError || lastNameError || emailError) {
      const firstError = firstNameError || lastNameError || emailError;
      setMessage(createToastMessage(firstError || "Please fix the validation errors", "warning", 3000));
      return;
    }
    if (!firstName.trim() || !lastName.trim()) {
      setMessage(createToastMessage("Please fill all fields", "warning", 3000));
      return;
    }
    if (isAuditorRole && selectedSkills.length === 0) {
      setMessage(createToastMessage("Please select at least one skill", "warning", 3000));
      return;
    }
    handleSaveEditedUser();
  };
  const handleSelectAllSkills = () => {
    const updatedSkills = isAllSelected ? [] : allSkillValues;
    setSelectedSkills(updatedSkills);
    handleEditInputChange({ target: { name: 'skills', value: updatedSkills } } as unknown as React.ChangeEvent<HTMLInputElement>);
  };
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit {roles.find(role => role.id === editUserData.roleId)?.name}</h2>
        <form>
          <label> First Name:
            <input type="text" name="firstName" value={editUserData.firstName} onChange={handleInputChangeWithValidation} className={fieldErrors.firstName ? 'error' : ''} />
            {fieldErrors.firstName && <span className="error-message">{fieldErrors.firstName}</span>}
          </label>
          <label> Last Name:
            <input type="text" name="lastName" value={editUserData.lastName} onChange={handleInputChangeWithValidation} className={fieldErrors.lastName ? 'error' : ''} />
            {fieldErrors.lastName && <span className="error-message">{fieldErrors.lastName}</span>}
          </label>
          <label> Email:
            <input type="email" name="email" value={editUserData.email} onChange={handleInputChangeWithValidation} className={`readonly-input ${fieldErrors.email ? 'error' : ''}`} readOnly />
            {fieldErrors.email && (
              <span className="error-message">{fieldErrors.email}</span>
            )}
          </label>
          {isAuditorRole && (
            <div className="skills-container">
              <span className="skills-label">Skills:</span>
              <div className="skills-checkbox-container">
                <div className="skill-checkbox-item">
                  <input type="checkbox" id="select-all-skills-edit" checked={isAllSelected} onChange={handleSelectAllSkills} />
                  <label htmlFor="select-all-skills-edit">
                    <strong>Select All Skills</strong>
                  </label>
                </div>
                {auditorSkills.map(skill => (
                  <div key={skill.value} className="skill-checkbox-item">
                    <input type="checkbox" id={`skill-${skill.value}`} checked={selectedSkills.includes(skill.value)} onChange={() => handleSkillChange(skill.value)} />
                    <label htmlFor={`skill-${skill.value}`}>{skill.description}</label>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="modal-buttons">
            <button type="button" onClick={() => setIsEditUserPopupVisible(false)}>Cancel</button>
            <button type="button" onClick={handleValidationAndSave}>Save</button>
          </div>
        </form>
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
    </div>
  );
};
export default EditUserPopup;